import { addDays, endOfWeek, format, isSameDay, parseISO, startOfWeek, } from "date-fns";
import { durationMinutes } from "./duration";
/** Mon-Sun week boundaries. */
export const weekStart = (d) => startOfWeek(d, { weekStartsOn: 1 });
export const weekEnd = (d) => endOfWeek(d, { weekStartsOn: 1 });
export function weekDays(d) {
    const start = weekStart(d);
    return Array.from({ length: 7 }, (_, i) => addDays(start, i));
}
export function formatWeekRange(d) {
    const s = weekStart(d);
    const e = weekEnd(d);
    return `${format(s, "d MMM")} – ${format(e, "d MMM yyyy")}`;
}
export function formatDateTime(iso) {
    return format(parseISO(iso), "d MMM yyyy");
}
export function formatDay(iso) {
    return format(parseISO(iso), "d MMM yyyy");
}
export function hoursBetween(startIso, endIso) {
    return durationMinutes({ msdyn_start: startIso, msdyn_end: endIso }) / 60;
}
export const sameDay = isSameDay;
